/* recently-viewed.js */

const RECENTLY_VIEWED_KEY = "aaliyans_recently_viewed";
const MAX_ITEMS = 12;

function trackView(handle) {
  if (!handle) return;
  let list = getRecentlyViewed().filter(h => h !== handle);
  list.unshift(handle);
  list = list.slice(0, MAX_ITEMS);
  localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(list));
}

function getRecentlyViewed() {
  try { return JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY)) || []; }
  catch { return []; }
}

document.addEventListener("DOMContentLoaded", async () => {
  // On a product page, record this product (set on the .product-page wrapper in main-product.liquid).
  const currentHandle = document.querySelector("[data-product-handle]")?.dataset.productHandle;
  if (currentHandle) trackView(currentHandle);

  const section = document.querySelector("[data-recently-viewed-section]");
  if (!section) return;

  // Exclude the product currently being viewed from its own carousel.
  const handles = getRecentlyViewed().filter(h => h !== currentHandle);
  if (!handles.length) return;

  const track = section.querySelector("[data-recently-viewed-track]");
  const products = await Promise.all(
    handles.map(h => fetch(`/products/${h}.js`).then(r => r.ok ? r.json() : null).catch(() => null))
  );

  const valid = products.filter(Boolean);
  if (!valid.length) return;

  track.innerHTML = valid.map(p => `
    <article class="card">
      <div class="card-media">
        <a href="/products/${p.handle}"><img src="${p.featured_image}" width="500" height="650" alt="${p.title}" loading="lazy"></a>
      </div>
      <div class="card-body">
        <a href="/products/${p.handle}" class="card-title">${p.title}</a>
        <div class="card-price"><span class="new">${(p.price / 100).toLocaleString(undefined, { style: "currency", currency: window.Shopify?.currency?.active || "PKR" })}</span></div>
      </div>
    </article>
  `).join("");

  section.hidden = false;
});
